import axiosClient from "@/api/common/axiosClient.ts";
import { Transaction } from "@/types/transaction.ts";
import { PaginatedResponse } from "@/api/types.ts";

export const getTransactions = () => {
  return axiosClient.get<PaginatedResponse<Transaction>>("transactions/me/");
};
